import script from "./AssetDetailPriceContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailPriceContent.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailPriceContent.vue?vue&type=style&index=0&id=305efa75&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305efa75"]])

export default __exports__